/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonArticleType,
    JsonArticleTypeFromJSON,
    JsonArticleTypeFromJSONTyped,
    JsonArticleTypeToJSON,
} from './JsonArticleType';

/**
 * 
 * @export
 * @interface ApiResultOfJsonArticleType
 */
export interface ApiResultOfJsonArticleType {
    /**
     * 
     * @type {JsonArticleType}
     * @memberof ApiResultOfJsonArticleType
     */
    data?: JsonArticleType;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleType
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonArticleType
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleType
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticleType
     */
    result?: ApiResultOfJsonArticleTypeResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonArticleTypeResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonArticleTypeFromJSON(json: any): ApiResultOfJsonArticleType {
    return ApiResultOfJsonArticleTypeFromJSONTyped(json, false);
}

export function ApiResultOfJsonArticleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonArticleType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonArticleTypeFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonArticleTypeToJSON(value?: ApiResultOfJsonArticleType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonArticleTypeToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

